import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseService } from '@/core/api/base-service';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { environment } from '../../../../../../../environments/environment';
import { SICOM_PATHS } from 'src/sicom-paths';
import { RefisPortariaRequest, RefisPortariaResponse } from './refis-portaria.model';

@Injectable({ providedIn: 'root' })
export class RefisPortariaService extends BaseService {
    private readonly PATH = SICOM_PATHS.financeiro.arrecadacao.refisPortaria;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    /** Lista as portarias. UF vazia ou "BR" lista todas; caso contrário filtra pela UF. */
    listar(uf?: string): Observable<RefisPortariaResponse[]> {
        let params = new HttpParams();
        if (uf) {
            params = params.set('uf', uf);
        }
        return this.http.get<RefisPortariaResponse[]>(`${this.rootUrl}${this.PATH}`, { params });
    }

    /** UF do usuário autenticado (para exibição somente-leitura). */
    obterUf(): Observable<string> {
        return this.http.get<{ uf: string }>(`${this.rootUrl}${this.PATH}/uf`).pipe(map((r) => r.uf));
    }

    salvar(request: RefisPortariaRequest): Observable<RefisPortariaResponse[]> {
        return this.http.post<RefisPortariaResponse[]>(`${this.rootUrl}${this.PATH}`, request);
    }

    excluir(id: number): Observable<void> {
        return this.http.delete<void>(`${this.rootUrl}${this.PATH}/${id}`);
    }
}
